// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.32.1
// source: aerial_interfaces/msg/PositionQuality.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "aerial_interfaces.msg.pb";

/**
 * GNSS position quality summary used in AerialState.
 * This keeps consumers decoupled from sensor_msgs/NavSatFix internals.
 */
export interface PositionQuality {
  /** One of FIX_* constants above. */
  fix_type: PositionQuality_FixTypeEnum;
  /** Horizontal 1-sigma accuracy in meters. */
  horizontal_accuracy: number;
  /** Vertical 1-sigma accuracy in meters. */
  vertical_accuracy: number;
  /** True when RTK corrections are active/available. */
  rtk_enabled: boolean;
}

export enum PositionQuality_FixTypeEnum {
  /**
   * FIX_UNKNOWN - Normalized fix categories (ordered by quality).
   * Unknown or not yet initialized fix state.
   */
  FIX_UNKNOWN = 0,
  /** FIX_NO_FIX - No valid GNSS position fix. */
  FIX_NO_FIX = 1,
  /** FIX_2D - 2D position fix (latitude/longitude only). */
  FIX_2D = 2,
  /** FIX_3D - 3D position fix (latitude/longitude/altitude). */
  FIX_3D = 3,
  /** FIX_DGPS - Differential GNSS corrected fix (SBAS/DGPS class). */
  FIX_DGPS = 4,
  /** FIX_RTK_FLOAT - RTK fix with floating carrier-phase ambiguity. */
  FIX_RTK_FLOAT = 5,
  /** FIX_RTK_FIXED - RTK fix with fixed carrier-phase ambiguity (highest precision). */
  FIX_RTK_FIXED = 6,
  UNRECOGNIZED = -1,
}

export function positionQuality_FixTypeEnumFromJSON(object: any): PositionQuality_FixTypeEnum {
  switch (object) {
    case 0:
    case "FIX_UNKNOWN":
      return PositionQuality_FixTypeEnum.FIX_UNKNOWN;
    case 1:
    case "FIX_NO_FIX":
      return PositionQuality_FixTypeEnum.FIX_NO_FIX;
    case 2:
    case "FIX_2D":
      return PositionQuality_FixTypeEnum.FIX_2D;
    case 3:
    case "FIX_3D":
      return PositionQuality_FixTypeEnum.FIX_3D;
    case 4:
    case "FIX_DGPS":
      return PositionQuality_FixTypeEnum.FIX_DGPS;
    case 5:
    case "FIX_RTK_FLOAT":
      return PositionQuality_FixTypeEnum.FIX_RTK_FLOAT;
    case 6:
    case "FIX_RTK_FIXED":
      return PositionQuality_FixTypeEnum.FIX_RTK_FIXED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PositionQuality_FixTypeEnum.UNRECOGNIZED;
  }
}

export function positionQuality_FixTypeEnumToJSON(object: PositionQuality_FixTypeEnum): string {
  switch (object) {
    case PositionQuality_FixTypeEnum.FIX_UNKNOWN:
      return "FIX_UNKNOWN";
    case PositionQuality_FixTypeEnum.FIX_NO_FIX:
      return "FIX_NO_FIX";
    case PositionQuality_FixTypeEnum.FIX_2D:
      return "FIX_2D";
    case PositionQuality_FixTypeEnum.FIX_3D:
      return "FIX_3D";
    case PositionQuality_FixTypeEnum.FIX_DGPS:
      return "FIX_DGPS";
    case PositionQuality_FixTypeEnum.FIX_RTK_FLOAT:
      return "FIX_RTK_FLOAT";
    case PositionQuality_FixTypeEnum.FIX_RTK_FIXED:
      return "FIX_RTK_FIXED";
    case PositionQuality_FixTypeEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBasePositionQuality(): PositionQuality {
  return { fix_type: 0, horizontal_accuracy: 0, vertical_accuracy: 0, rtk_enabled: false };
}

export const PositionQuality: MessageFns<PositionQuality> = {
  encode(message: PositionQuality, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fix_type !== 0) {
      writer.uint32(3909198696).int32(message.fix_type);
    }
    if (message.horizontal_accuracy !== 0) {
      writer.uint32(2742034089).double(message.horizontal_accuracy);
    }
    if (message.vertical_accuracy !== 0) {
      writer.uint32(508152961).double(message.vertical_accuracy);
    }
    if (message.rtk_enabled !== false) {
      writer.uint32(1853352536).bool(message.rtk_enabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PositionQuality {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePositionQuality();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 488649837: {
          if (tag !== 3909198696) {
            break;
          }

          message.fix_type = reader.int32() as any;
          continue;
        }
        case 342754261: {
          if (tag !== 2742034089) {
            break;
          }

          message.horizontal_accuracy = reader.double();
          continue;
        }
        case 63519120: {
          if (tag !== 508152961) {
            break;
          }

          message.vertical_accuracy = reader.double();
          continue;
        }
        case 231669067: {
          if (tag !== 1853352536) {
            break;
          }

          message.rtk_enabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PositionQuality {
    return {
      fix_type: isSet(object.fixType)
        ? positionQuality_FixTypeEnumFromJSON(object.fixType)
        : isSet(object.fix_type)
        ? positionQuality_FixTypeEnumFromJSON(object.fix_type)
        : 0,
      horizontal_accuracy: isSet(object.horizontalAccuracy)
        ? globalThis.Number(object.horizontalAccuracy)
        : isSet(object.horizontal_accuracy)
        ? globalThis.Number(object.horizontal_accuracy)
        : 0,
      vertical_accuracy: isSet(object.verticalAccuracy)
        ? globalThis.Number(object.verticalAccuracy)
        : isSet(object.vertical_accuracy)
        ? globalThis.Number(object.vertical_accuracy)
        : 0,
      rtk_enabled: isSet(object.rtkEnabled)
        ? globalThis.Boolean(object.rtkEnabled)
        : isSet(object.rtk_enabled)
        ? globalThis.Boolean(object.rtk_enabled)
        : false,
    };
  },

  toJSON(message: PositionQuality): unknown {
    const obj: any = {};
    if (message.fix_type !== 0) {
      obj.fixType = positionQuality_FixTypeEnumToJSON(message.fix_type);
    }
    if (message.horizontal_accuracy !== 0) {
      obj.horizontalAccuracy = message.horizontal_accuracy;
    }
    if (message.vertical_accuracy !== 0) {
      obj.verticalAccuracy = message.vertical_accuracy;
    }
    if (message.rtk_enabled !== false) {
      obj.rtkEnabled = message.rtk_enabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PositionQuality>, I>>(base?: I): PositionQuality {
    return PositionQuality.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PositionQuality>, I>>(object: I): PositionQuality {
    const message = createBasePositionQuality();
    message.fix_type = object.fix_type ?? 0;
    message.horizontal_accuracy = object.horizontal_accuracy ?? 0;
    message.vertical_accuracy = object.vertical_accuracy ?? 0;
    message.rtk_enabled = object.rtk_enabled ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
